"use strict";

exports.__esModule = true;
exports.AdvancedDataTableWidget = void 0;
var _react = _interopRequireDefault(require("react"));
var _ChartCard = require("../common/ChartCard");
var _reactIntl = require("react-intl");
var _AdvancedDataTableElement = require("./AdvancedDataTableElement");
var _AdvancedDataTableFields = require("./AdvancedDataTableFields");
var _AdvancedDataTableThumbnail = require("./AdvancedDataTableThumbnail");
var _widgetGroups = require("../widgetGroups");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var AdvancedDataTableWidget = exports.AdvancedDataTableWidget = {
  name: "AdvancedDataTable",
  label: /*#__PURE__*/_react["default"].createElement(_reactIntl.FormattedMessage, {
    id: "AdvancedDataTableWidget.label",
    defaultMessage: "Timeline Table"
  }),
  icon: "th-list",
  group: _widgetGroups.TIMELINE_WIDGET,
  createElement: function createElement(props) {
    return {
      type: "AdvancedDataTable",
      props: Object.assign({
        dataSource: "",
        dataRange: "",
        width: 512,
        height: 512
      }, props),
      children: []
    };
  },
  showInPalette: true,
  isParent: true,
  requiresContexts: [],
  suppliesContexts: [],
  optionalProps: ["fontFamily", "fontSize", "fontWeight", "fontStyle", "textDecoration", "textAlignment", "color", "onClickAction"],
  requiresProps: ["x", "y", "width", "height"],
  suppliesProps: [],
  propConstraints: {
    width: {
      "default": 320,
      min: 32,
      max: 1024
    },
    height: {
      "default": 320,
      min: 32,
      max: 768
    }
  },
  components: {
    Element: (0, _ChartCard.withChartCard)(_AdvancedDataTableElement.AdvancedDataTableElement),
    Fields: _AdvancedDataTableFields.AdvancedDataTableFields,
    Thumbnail: _AdvancedDataTableThumbnail.AdvancedDataTableThumbnail
  }
};